export const API_HOST = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:3000' : '/api'

export const OSS_URL = (process.env.VUE_APP_OSS_URL || 'https://assets.flymeta.com').replace(/\/+$/, '')

export const LOCALES_SOURCE = process.env.VUE_APP_LOCALES_SOURCE === 'production-oss' ? 'production-oss' : 'api'

export const LOCALES_URL = LOCALES_SOURCE === 'production-oss'
  ? `${OSS_URL}/flymeta-home/locales.json`
  : `${API_HOST}/locales`
